import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { HoldingsProjectForm } from "./Main";
import {
  useGetHoldingsUpdateInfoQuery,
  useGetHoldingsUpdateAffiliatedStoreCompanyInfoQuery,
  useGetAuthQuery,
} from "../../features/api";
import { USER_TYPE } from "../../configs/constants";

/*
ホールディングス案件照会・更新画面(事業者情報)
 */
export const Update = () => {
  //パラメータの事業者コードを取得
  const { companyCode } = useParams();

  const { loginCompanyType, loginCompanyCode } = useGetAuthQuery(undefined, {
    selectFromResult: ({ data }) => ({
      loginCompanyType: data?.companyType,
      loginCompanyCode: data?.companyCode,
    }),
  });

  const paramCompanyCode =
    loginCompanyType === USER_TYPE.HD ? loginCompanyCode : companyCode;

  //ホールディングス案件情報取得
  const { data: holdingsProjectData, refetch: refetch1 } =
    useGetHoldingsUpdateInfoQuery(paramCompanyCode);

  //ホールディングス契約情報取得
  const {
    data: holdingsAffiliatedStoreCompanyData,
    isFetching,
    refetch: refetch2,
  } = useGetHoldingsUpdateAffiliatedStoreCompanyInfoQuery(paramCompanyCode);

  useEffect(() => {
    refetch1();
    refetch2();
  }, [refetch1, refetch2]);

  return (
    <HoldingsProjectForm
      holdingsProjectData={holdingsProjectData}
      holdingsAffiliatedStoreCompanyData={holdingsAffiliatedStoreCompanyData}
      refetchHoldingsAffiliatedStoreCompanyData={refetch2}
      isFetching={isFetching}
    />
  );
};
